import Page from 'components/layout/Page';
import {
  Heading1,
  Heading2,
  Heading3
} from 'components/shared/Typography.styled';
import { useRouter } from 'next/dist/client/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledTermsOfUse } from './TermsOfUseComponent.styled';
import { useI18n } from 'hooks/useI18n';
import HtmlTrans from 'components/shared/HtmlTrans';
import React from 'react';
import { LinkText } from 'components/shared/LinkText';

const TermsOfUseComponent: React.FC = () => {
  const { locale } = useRouter();
  const { t } = useI18n('terms-of-use');

  return (
    <Page hasScrollTop>
      <StyledTermsOfUse>
        <Heading1 editorial>{t('terms-of-use.title')}</Heading1>

        <Heading2>{t('terms-of-use.sections.section1_title')}</Heading2>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.section1_desc'}
          components={{
            mail: <a href="mailto:hello@getmanfred.com">hello@getmanfred.com</a>
          }}
        />

        <Heading2>{t('terms-of-use.sections.section2_title')}</Heading2>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.section2_desc'}
        />

        <Heading2>{t('terms-of-use.sections.section3_title')}</Heading2>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.section3_desc'}
        />

        <Heading2>{t('terms-of-use.sections.section4_title')}</Heading2>
        <Heading3>{t('terms-of-use.sections.subsection4_1_title')}</Heading3>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.subsection4_1_desc'}
        />
        <Heading3>{t('terms-of-use.sections.subsection4_2_title')}</Heading3>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.subsection4_2_desc'}
        />

        <Heading2>{t('terms-of-use.sections.section5_title')}</Heading2>
        <Heading3>{t('terms-of-use.sections.subsection5_1_title')}</Heading3>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.subsection5_1_desc'}
        />
        <Heading3>{t('terms-of-use.sections.subsection5_2_title')}</Heading3>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.subsection5_2_desc'}
        />
        <Heading3>{t('terms-of-use.sections.subsection5_3_title')}</Heading3>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.subsection5_3_desc'}
        />
        <Heading3>{t('terms-of-use.sections.subsection5_4_title')}</Heading3>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.subsection5_4_desc'}
        />

        <Heading2>{t('terms-of-use.sections.section6_title')}</Heading2>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.section6_desc'}
        />

        <Heading2>{t('terms-of-use.sections.section7_title')}</Heading2>
        <HtmlTrans
          ns={'terms-of-use'}
          i18nKey={'terms-of-use.sections.section7_desc'}
          components={{
            privacy: (
              <LinkText href={getAppUrl(APP_URLS.privacyPolicy, locale)} />
            )
          }}
        />
      </StyledTermsOfUse>
    </Page>
  );
};

export default TermsOfUseComponent;
